import React from 'react';
import ProjectPriorityRow from './projectPriorityRow/index';

const ProjectPriorityList = ({
    width,
    data,
    addFavouriteProjectPriority,
    onProjectPrioritySelect,
    onSaveProjectPriority,
    onDeleteProjectPriority,
    showProjectPriorityLoader,
    updatingGlobalPriorities,
    projectList,
    onSaveProject,
    showProjectLoader,
    onUpdateProjectPriorities,
}) => {
    return (
        <div className="app-main-content">
            {data.map((data, index) => <ProjectPriorityRow key={index} 
                width={width}
                projectPriority={data}
                showProjectLoader={showProjectLoader}
                projectList={projectList}
                onSaveProject={onSaveProject}
                updatingGlobalPriorities={updatingGlobalPriorities}
                onDeleteProjectPriority={onDeleteProjectPriority}
                onSaveProjectPriority={onSaveProjectPriority}
                showProjectPriorityLoader={showProjectPriorityLoader}
                addFavouriteProjectPriority={addFavouriteProjectPriority}
                onProjectPrioritySelect={onProjectPrioritySelect}
                onUpdateProjectPriorities={onUpdateProjectPriorities}
            />
            )}
        </div>
    );
};

export default ProjectPriorityList;


// WEBPACK FOOTER //
// ./components/Agile/projectPriority/projectPriorityList/index.js